const ApplicationMenuConfig = {
    style: {
        textClass: '',
        textActiveClass: 'active',
        menuClass: 'p-0 border-0',
    },
    pages: [
        { name: 'Accueil', title: 'Accueil' },
        { name: 'About', title: 'A propos de' }
    ]
};

export default ApplicationMenuConfig;